<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><strong><a id="page_iii"></a><a id="ch002_title"></a>Victory Girls, Khaki-Wackies, and Patriotutes</strong></h1>
<p class="bsubtitleleftg"><em>The Regulation of Female Sexuality during World War II</em></p>
<p class="authorleft">Marilyn E. Hegarty</p>
<p class="image1"><img alt="image" src="images/f0003-1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002_title.vue?c92d721c